// extracted by mini-css-extract-plugin
module.exports = {"languageIconButton":"LanguageCodeInput_languageIconButton__2UtZP","languageFlagButton":"LanguageCodeInput_languageFlagButton__1jXIG"};